export const trackingEventSegmentSubscriptionStatusTransition = "subscription_status_transition";
//# sourceMappingURL=subscriptions.js.map